import processOptionResolutions from "./process-option-resolutions";

/**
 * Extract and process options
 * @param {String} input
 * @param {MainClassProps | null} main
 * @param {Number} count
 * @returns {OptionsProps}
 */
const getOptions = (input, main, count) => {
  if (!input) {
    return null;
  }

  const sliced = input.slice(1, -1);
  const split = sliced.split("░");
  const values = processOptionResolutions(split, main, true, count, false);

  return values;
};

export default getOptions;
